/**
 * Proje ve hizmet teslimi — menü metni (v4.5 B-1a). Kabuk menüsü ilk pakete girdiğinden küçük tutulur; ekran metinleri
 * `delivery-strings.ts` içindedir (tembel yüklenen sayfa parçasında).
 */
export const deliveryNavText = {
  nav: 'Projeler ve hizmetler',
};
